import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Spinner from './Spinner';

const MailItemSpon = ({ match }) => {

const [loading, setLoading] = useState(true);
const [unread, setUnread] = useState(false);
const [mess, setMess] = useState({});

const fetchMessage = async () => {
    const fetchItem = await fetch(`${process.env.REACT_APP_API_URL}/b/fullsponmessage/${ match.params.messageid }`, { headers: { 'x-api-key': localStorage.getItem('x-api-key')} });
    const item = await fetchItem.json();
    const content = item[0];
    setMess(content);
    setLoading(false);
    if (content.unread === true) {
        const respond = await fetch(`${process.env.REACT_APP_API_URL}/b/sponmarkasread/${ match.params.messageid }`, { headers: { 'x-api-key': localStorage.getItem('x-api-key')} });
        setUnread(false);
    } else return;
};

useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

useEffect(() => {
   fetchMessage();
  }, [])

return (
    <div>
            <br />
            <br />
            <br />
            {
        (loading) ? ( <Spinner /> ) : (
            <div className="glass-account-edit">
                <h1>✉️ Message from</h1>
                <h1>{mess.username}</h1>
                <div className="glass-giveaway-details">
                <h2>{mess.message}</h2>
                <p><small>Received at {new Date(mess.created_at).toUTCString()}</small></p>
                </div>
                <br />
                <div className="giveaway-button">
                <h3><Link to={`/businessreply/${mess.messageid}`}>Reply</Link></h3>
                </div>
                <br />
                <p><Link to={`/businessmailbox`}>Back to Mailbox</Link></p>
      <br />
      </div>)
}
            <br />
            <br />
            <br />
            <br />
    </div>
)

}

export default MailItemSpon;